import React, { useState } from 'react'
import '../../App.css'
import { useNavigate , Form, Link} from 'react-router-dom'
import { useCookies } from 'react-cookie';
import {apiurl,host} from '../../path';
import { login_side_img, maharashtra } from '../../public/LoginImages/importimages';

const AdminLogin = () => {
    const navigate = useNavigate();
    const [cookies, setCookie,removeCookie] = useCookies();
    const [form,setform]=useState({
        username:"",
        Password:""
      })
    
    const login=async()=>{
        try {
          console.log('form data',form);
          
          let logincheck=await fetch(apiurl+'/AdminLogin',
        {method:"POST",
        headers:({'Content-Type': 'Application/json'}),
        body:JSON.stringify({...form})})
        logincheck= await logincheck.json()
        console.log('response',logincheck);
        
       if(logincheck){
        let a=localStorage.setItem("Token",logincheck)
        setCookie("userId", logincheck, { path: '/' })
        window.location.href='/AdminDashboard'
       }else{
        alert('Incorrect id or password')
       }
        } catch (error) {
          console.error("Error in AdminLogin:", error);
        }
       
    }
  function PasswordManager(e) {
    let input = e.currentTarget.parentNode.children[0]
    let eye = e.currentTarget.parentNode.children[1]
    input.type==='password'?input.type='text':input.type='password'
    
    eye.className==="fa-regular fa-eye"?eye.className="fa-regular fa-eye-slash":eye.className="fa-regular fa-eye"
   
  }
    return (
        <div style={{ backgroundColor:"white", height: "100vh", width: '100vw', backgroundSize: 'cover',display:"flex",justifyContent:"space-between"}}>
          <img src={login_side_img} style={{width:"60vw"}}/>
        <div style={{display:'flex',height:"100vh",alignItems:"center" }}>
        <Form onSubmit={()=>login()}>
          <div className="card" style={{width: "25rem",backgroundColor:'rgb(135 147 189 / 0%)',marginRight:"100px",border:"none"}}>
            <img className="card-img-top" style={{width:"8rem",display:"grid",alignSelf:"center"}} src={maharashtra}alt="Card image cap"/>
              <div className="card-body">
                <div style={{display:"grid",justifyContent:"center"}}>
                <h3><b>Admin Login</b></h3>
                <p className="card-text" style={{color:"#999999"}}>Please enter your details</p>
                </div>
                <div>
                <i style={{position:'relative',backgroundColor:'transparent',zIndex:0,fontSize:'12px'}} className='mx-3'><b>Username</b></i>
                <input style={{border:"none",borderRadius:"0",borderBottom:"2px solid"}} type='text' className='form-control' id="username" placeholder='Enter Username Here' onChange={(e)=>setform({...form,[e.target.id]:e.target.value})} required></input>
                </div>
                <i style={{position:'relative',backgroundColor:'transparent',fontSize:'12px'}} className='mx-3'><b>Password</b></i>
                <div style={{display:"flex"}}>
                <input style={{border:"none",borderRadius:"0",borderBottom:"2px solid"}} type='password' className='form-control' id="Password" placeholder='Enter Password Here' onChange={(e)=>setform({...form,[e.target.id]:e.target.value})} required ></input>
                <i style={{position:"relative",right:"20px"}} className="fa-regular fa-eye" onClick={(e)=>PasswordManager(e)}> </i>
                </div>
                <div className='mx-3 my-3' style={{display:"flex",justifyContent:"space-between"}}>
                  <div style={{display:"flex"}}>
                    <div style={{paddingRight:"2px"}}>
                      <input type='checkbox'/>
                    </div>
                    <p style={{fontWeight:"500"}}>Remember for 30 days</p>
                  </div>
                  <div>
                    <p style={{color:"#999999"}}><a href='/ForgetPassword'>Forgot Password?</a></p>
                  </div>
                </div>
                <button type='submit' className="btn btn-primary my-3" style={{width:"100%",border:"1px solid red",borderRadius:"20px",backgroundColor:"#e73d26"}}>Login</button>
              </div>
          </div>
        </Form>
        </div>
      </div>
    )
}

export default AdminLogin